import React, { useEffect, useState } from 'react';
import styles from './index.module.css';
import { Calendar, Drawer, Tabs, TabsProps } from 'antd';
import { formatToINR } from '../../../../Utils/utils';
import { DollarOutlined, FallOutlined } from '@ant-design/icons';

import CashFlow from '../CashFlow';
import Merchant from '../Merchant';
import Category from '../Category';
import BankSummary from '../BankSummary';
import TopSummarySection from '../../TopSummarySection';
import { getBankAccountsBalance } from '../../../../Utils/storageUtils';
import Nudges from '../../Nudges';
import Nudge from '../../../../Models/Nudge';
import CalendarView from '../../Calendar';
import CategoryAnalysis from '../Category/CategoryAnalysis';
import getNudges from '../../../../Utils/nudgeUtils';

type Props = {
  onBack: () => void;
  defaultTab: any;
};

const Home: React.FC<Props> = (props: Props) => {
  const [showMerchantData, setShowMerchantData] = useState(false);
  const [showCategoryAnalysis, setShowCategoryAnalysis] = useState(false);
  const [defaultActiveKey, setDefaultActiveKey] = useState<string>();
  const [currentMonthYear, setCurrentMonthYear] = useState<any>();
  const [txnType, setTxnType] = useState('');
  const [currentDataKey, setCurrentDataKey] = useState<any>('totalDebitAmount');
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Your Banks',
      children: <BankSummary />,
    },
    {
      key: '2',
      label: 'Analytics',
      children: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <CashFlow
            setCurrentMonth={setCurrentMonthYear}
            setCurrentDataKey={setCurrentDataKey}
            isFromCashFlow={false}
            setType={setTxnType}
          />
          <Category
            currentMonthYearProp={currentMonthYear}
            currentDataKey={currentDataKey}
            viewAll={() => setShowCategoryAnalysis(true)}
          />
          <Nudges nudgeList={getNudges('analysis')} />
          <Merchant
            txnType={txnType}
            viewAll={() => setShowMerchantData(true)}
            currentMonthYearProps={currentMonthYear}
          />
        </div>
      ),
    },
    {
      key: '3',
      label: 'Cash Flow',
      children: (
        <CashFlow
          setCurrentMonth={setCurrentMonthYear}
          setCurrentDataKey={setCurrentDataKey}
          isFromCashFlow={true}
          setType={() => {}}
        />
      ),
    },
    {
      key: '4',
      label: 'Calendar',
      children: <CalendarView />,
    },
  ];

  useEffect(() => {
    setDefaultActiveKey(props.defaultTab ? props.defaultTab.toString() : '1');
  }, []);

  return (
    <div className={styles.spends_home_container}>
      {showMerchantData ? (
        <>
          <Merchant
            txnType={txnType}
            viewAll={() => {}}
            isViewAll={showMerchantData}
            setViewAll={() => {
              setShowMerchantData(!showMerchantData);
              setDefaultActiveKey('2');
            }}
            currentMonthYearProps={currentMonthYear}
          />
        </>
      ) : showCategoryAnalysis ? (
        <Category
          currentMonthYearProp={currentMonthYear}
          currentDataKey={currentDataKey}
          viewAll={() => {}}
          isViewAll={showCategoryAnalysis}
          setViewAll={() => {
            setShowCategoryAnalysis(!showCategoryAnalysis);
            setDefaultActiveKey('2');
          }}
        />
      ) : (
        <>
          <TopSummarySection
            subTitle={formatToINR(getBankAccountsBalance().toString())}
            title="Savings Account Balance"
            isBackButton={true}
            onBack={props.onBack}
          />
          <div style={{ padding: '0 16px' }}>
            {defaultActiveKey && (
              <Tabs defaultActiveKey={defaultActiveKey} items={items} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
